import type { IconSvgObject } from './types';

const WebProtectionIcon: IconSvgObject = [
  ["path", { d: "M3 7.5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 20.5H5C3.89543 20.5 3 19.6046 3 18.5V4.5C3 3.39543 3.89543 2.5 5 2.5H19C20.1046 2.5 21 3.39543 21 4.5V9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 17V14.5C19 14.5 17.5 13.5 17.5 13.5C17.5 13.5 16 14.5 14 14.5V17C14 20.5 17.5 21.5 17.5 21.5C17.5 21.5 21 20.5 21 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default WebProtectionIcon;
